import { render, staticRenderFns } from "./BlondWaiting1.vue?vue&type=template&id=c590d0a2&"
import script from "./BlondWaiting1.vue?vue&type=script&lang=ts&"
export * from "./BlondWaiting1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports